<template>
  <v-dialog v-model="dialog" :persistent="true" max-width="50%">
    <v-card class="PlanejamentoAcaoFormCampos__Card--treslinhas">
      <v-card-title>
        <div class="card-title">
          {{ $tc('title.rateio_entre_naturezas_operacao', 1) }}
        </div>
      </v-card-title>
      <v-card-text class="pb-4">
        <v-container fluid class="pb-0">
          <v-row dense class="valores-header" justify="space-between" no-gutters>
            <v-col class="valor-item pr-2">
              {{ $tc('label.valor_total') }}: {{ getMoney(valorTotalAcao) }}
            </v-col>
            <v-col class="valor-item pr-2">
              {{ $tc('label.valor_pendente') }}: {{ getMoney(valorPendente) }}
            </v-col>
            <v-col class="valor-item pr-2">
              {{ $tc('label.valor_alocado') }}: {{ getMoney(valorAlocado) }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-text class="p-0">

        <template v-if="!indPossuiNotasAgrupadas">
          <v-data-table
            id="tabela_linha_rateio"
            :headers="headersLinhaRateio"
            :items="listaRateio"
            :no-data-text="$t('label.tabela_sem_conteudo')"
            :footer-props="{ itemsPerPageOptions: [5, 10] }"
            :items-per-page="5"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="(item, index) in items" :key="index">
                  <td>{{ item.nome_tipo_uso }}</td>
                  <td>{{ item.cod_budget_id }}</td>
                  <td>{{ getMoney(item.valor) }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </template>

        <template v-else>
          <v-expansion-panels v-model="painelAberto" focusable>
            <v-expansion-panel
              v-for="(rateioFornecedor, i) in listaRateioPorFornecedor"
              :key="i"
            >
              <v-expansion-panel-header>
                <v-row no-gutters class="align-center w-100">
                  <v-col cols="3">
                    <strong>{{ rateioFornecedor.num_nota_debito }}</strong>
                  </v-col>
                  <v-col cols="9" class="pr-6">
                    <v-row no-gutters justify="end">

                      <v-col cols="auto" class="text-right grey--text text--darken-1 pr-2">
                        {{ $tc('label.valor_total_rateio', 1) }}:
                      </v-col>

                      <v-col style="width: 130px; max-width: 130px;">
                        {{ getMoney(rateioFornecedor.valorTotalRateio) }}
                      </v-col>

                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-data-table
                  :headers="headersLinhaRateio"
                  :items="rateioFornecedor.listalinhasrateio"
                  :no-data-text="$t('label.tabela_sem_conteudo')"
                  :footer-props="{ itemsPerPageOptions: [5, 10] }"
                  :items-per-page="5"
                  dense
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="(item, index) in items" :key="index">
                        <td>{{ item.nome_tipo_uso }}</td>
                        <td>{{ item.cod_budget_id }}</td>
                        <td>{{ getMoney(item.valor) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">{{$t('label.ok') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getMoney } from '@/common/functions/helpers';

export default {
  name: 'ModalRateioContabil',
  props: {
    notaDebito: {
      type: Object,
      default: () => ({}),
    },
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      planejamentoAcaoResource: this.$api.planejamentoAcaoCadastro(this.$resource),
      apuracaoListagemResource: this.$api.apuracaoAcaoVerbaVariavelListagem(this.$resource),
      dialog: false,
      valor: '',
      listaRateio: [],
      listaRateioPorFornecedor: [],
      indPossuiNotasAgrupadas: false,
      painelAberto: 0,
      valorTotalAcao: null,
      valorPendente: null,
      valorAlocado: null,
      headersLinhaRateio: [
        {
          text: this.$tc('label.tipo_uso', 1), value: 'nome_tipo_uso', sortable: false, width: '10%',
        },
        {
          text: this.$tc('label.budget_id', 1), value: 'cod_budget_id', sortable: false, width: '10%',
        },
        {
          text: this.$tc('label.valor', 1), value: 'valor', sortable: false, width: '10%',
        },
      ],
    };
  },
  methods: {
    getMoney,
    open(item) {
      this.indPossuiNotasAgrupadas = item.indPossuiNotasAgrupadas;
      if (item.indCadastroRateioContabilApuracao) {
        if (this.indPossuiNotasAgrupadas) {
          const idsFornecedor = item.idsFornecedorRateio.split(',').map((id) => parseInt(id.trim(), 10));
          this.carregaListaRateioContabilApuracaoPorFornecedor(item.idApuracao, idsFornecedor);
        } else {
          this.carregaListaRateioContabilApuracao(item.idApuracao, item.idFornecedor);
        }
      } else {
        this.indPossuiNotasAgrupadas = false;
        this.carregaListaRateioContabil(item.idAcao);
      }
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.limpaModal();
    },
    carregaListaRateioContabil(idAcao) {
      this.planejamentoAcaoResource.buscarValoresRateio({ idAcao })
        .then((res) => {
          this.listaRateio = res.body.listalinhasrateio;
          this.valorTotalAcao = res.body.valorTotal;
          this.valorPendente = res.body.valorPendente;
          this.valorAlocado = res.body.valorAlocado;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    calcularTotalFornecedor(linhasRateio) {
      if (!linhasRateio || linhasRateio.length === 0) {
        return 0;
      }
      return linhasRateio.reduce((total, item) => total + parseFloat(item.valor), 0);
    },
    carregaListaRateioContabilApuracaoPorFornecedor(idApuracao, idsFornecedor) {
      const params = { idApuracao, idsFornecedor };
      this.apuracaoListagemResource.buscarValoresRateioApuracaoNdPorFornecedor(params, params)
        .then((res) => {
          this.valorTotalAcao = res.body.valorTotal;
          this.valorPendente = res.body.valorPendente;
          this.valorAlocado = res.body.valorAlocado;

          const listaLinhasRateio = res.body.rateiosPorFornecedor;
          const rateiosComTotal = listaLinhasRateio.map((rateio) => {
            const totalDoRateio = rateio.listalinhasrateio.reduce((soma, linha) => soma + parseFloat(linha.valor), 0);
            return {
              ...rateio,
              valorTotalRateio: totalDoRateio,
            };
          });

          this.listaRateioPorFornecedor = rateiosComTotal;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    carregaListaRateioContabilApuracao(idApuracao, idFornecedor) {
      const params = {
        idApuracao,
        idFornecedor,
      };
      this.apuracaoListagemResource.buscarValoresRateioApuracaoNd(params, params)
        .then((res) => {
          this.listaRateio = res.body.listalinhasrateio;
          this.valorTotalAcao = res.body.valorTotal;
          this.valorPendente = res.body.valorPendente;
          this.valorAlocado = res.body.valorAlocado;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    limpaModal() {
      this.listaRateio = [];
      this.listaRateioPorFornecedor = [];
      this.indPossuiNotasAgrupadas = false;
      this.valorTotalAcao = null;
      this.valorPendente = null;
      this.valorAlocado = null;
    },
  },
};
</script>
<style lang="scss">
.justify {
  text-align: justify;
}
.valores-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.valor-item {
  white-space: nowrap;
  flex: 0;
  text-align: center;
}
</style>
